import {NgModule} from '@angular/core';

import {ThankYouComponent} from './thank-you.component';
import {ThankYouRoutingModule} from './thank-you-routing.module';

@NgModule({
  declarations: [
    ThankYouComponent,
  ],
  imports: [
    ThankYouRoutingModule
  ],
  providers: [],
  exports: [
    ThankYouComponent,
  ],
})
export class ThankYouModule {}
